import { put, delay, takeLatest } from "@redux-saga/core/effects";
import { addServiceRequestUpdate, createServiceRequest, editServiceRequest, fetchAllServiceRequest, fetchAllServiceRequestUpdates, fetchServiceRequestById } from "../../../Utils/BackendAPICalls";
import { Actions, Types } from "../../Reducer/rootReducer";
import { CreateServiceRequestData, Comment, UpdateServiceRequestData } from "../../../Types/UnitFeatureTypes";

interface ServiceRequestAction {
    payload: {
        serviceRequestData: CreateServiceRequestData;
    };
}

interface FetchServiceRequestAction {
    payload: {
        id?: string;
        offset?: number
        sortColumn?: string;
        sortDirection?: string;
    };
}

interface FetchServiceRequestUpdatesAction {
    payload: {
        service_request_id: string;
    };
}

interface EditServiceRequestFunction {
    payload: {
        id: string,
        serviceRequestData: UpdateServiceRequestData;
    }
}

interface AddServiceRequestUpdatesAction {
    payload: {
        serviceRequestUpdateData: Comment;
    }
}

export function* createServiceRequestFunction(action: ServiceRequestAction): Generator<any, void, Response> {
    const { serviceRequestData } = action.payload;
    try {
        yield delay(100);
        const response: any = yield createServiceRequest(serviceRequestData);
        if (!response || response?.error) {
            yield put(Actions.serviceRequest.addServiceRequestAction.failure({ message: response.error }));
        }
        yield put(Actions.serviceRequest.addServiceRequestAction.success({ serviceRequestId: response.id }));
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.serviceRequest.addServiceRequestAction.failure(error));
    }
}

export function* fetchServiceRequestFunction(action: FetchServiceRequestAction): Generator<any, void, Response> {
    const { id, offset, sortColumn, sortDirection  } = action.payload;
    let response: any = null;
    try {
        yield delay(100);
        if (id) {
            response = yield fetchServiceRequestById(id);
        } else {
            response = yield fetchAllServiceRequest(offset ?? 0, sortColumn ?? 'created_on', sortDirection ?? 'desc');
        }

        if (!response || response?.error) {
            yield put(Actions.fetch.serviceRequestActions.failure({ message: response.error }));
        } else {
            yield put(Actions.fetch.serviceRequestActions.success({
                serviceRequests: response.serviceRequests,
                serviceRequest: response.serviceRequest,
                count: response.count
            }));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetch.serviceRequestActions.failure(error));
    }
}

export function* editServiceRequestFunction(action: EditServiceRequestFunction): Generator<any, void, Response> {
    const { id, serviceRequestData } = action.payload;
    try {
        yield delay(100);
        const response:any = yield editServiceRequest(serviceRequestData, id);

        if (!response || response?.error) {
            yield put(Actions.serviceRequest.editServiceRequestAction.failure({ message: response.error }));
        } else {
            yield put(Actions.serviceRequest.editServiceRequestAction.success());
            yield put(Actions.fetch.serviceRequestActions.request({ id: id }));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.serviceRequest.editServiceRequestAction.failure(error));
    }

}

export function* addServiceRequestUpdatesFuntion(action: AddServiceRequestUpdatesAction): Generator<any, void, Response> {
    const { serviceRequestUpdateData } = action.payload;
    try {
        yield delay(100);
        const response:any = yield addServiceRequestUpdate(serviceRequestUpdateData);

        if (!response || response?.error) {
            yield put(Actions.serviceRequestUpdates.addServiceRequestUpdateAction.failure({ message: response.error }));
        } else {
            yield put(Actions.serviceRequestUpdates.addServiceRequestUpdateAction.success());
            yield put(Actions.fetchServiceRequestUpdates.serviceRequestUpdatesActions.request({
                service_request_id: serviceRequestUpdateData.resource_id
            }));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.serviceRequestUpdates.addServiceRequestUpdateAction.failure(error));
    }
}

export function* fetchServiceRequestUpdatesFunction(action: FetchServiceRequestUpdatesAction): Generator<any, void, Response> {
    const { service_request_id } = action.payload;
    let response: any = null;
    try {
        yield delay(100);
        if (service_request_id) {
            response = yield fetchAllServiceRequestUpdates(service_request_id);
        }

        if (!response || response?.error) {
            yield put(Actions.fetchServiceRequestUpdates.serviceRequestUpdatesActions.failure({ message: response.error }));
        } else {
            yield put(Actions.fetchServiceRequestUpdates.serviceRequestUpdatesActions.success({
                serviceRequestUpdates: response,
            }));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetchServiceRequestUpdates.serviceRequestUpdatesActions.failure(error));
    }
}


export default function* serviceRequestSaga() {
    yield takeLatest(Types.ADD_SERVICE_REQUEST_REQUEST, createServiceRequestFunction);
    yield takeLatest(Types.EDIT_SERVICE_REQUEST_REQUEST, editServiceRequestFunction);
    yield takeLatest(Types.FETCH_SERVICE_REQUESTS_REQUEST, fetchServiceRequestFunction);
    yield takeLatest(Types.ADD_SERVICE_REQUEST_UPDATE_REQUEST, addServiceRequestUpdatesFuntion);
    yield takeLatest(Types.FETCH_SERVICE_REQUEST_UPDATES_REQUEST, fetchServiceRequestUpdatesFunction);
}
